import React, { useState, useEffect } from "react";

const TypingText: React.FC<{ text: string; speed?: number }> = ({ text, speed = 85 }) => {
  const [displayed, setDisplayed] = useState("");

  useEffect(() => {
    let i = 0;
    const interval = setInterval(() => {
      setDisplayed((prev) => prev + text.charAt(i));
      i++;
      if (i >= text.length) clearInterval(interval);
    }, speed);
    return () => clearInterval(interval);
  }, [text, speed]);

  return <p className="section-sub"><b><h3>{displayed}</h3></b></p>;
};

export default TypingText;
